// @flow
import React from 'react'
import { DatePicker, DobDatePicker } from 'src/components/DatePicker'
import { FormField, StyledField, Label, Error } from 'src/components/Form'

import type { DateField as DateFieldProps } from 'src/types'

const customStyles = {
  container: (base, state) => ({
    ...base,
    width: '100%',
    height: '100%',
    margin: '7px 0',
    border: 'none',
    outline: 'none',
    boxShadow: 'none',
    borderColor: 'none'
  }),
  control: (base, state) => ({
    ...base,
    width: '100%',
    height: '100%',
    borderRadius: '3px',
    fontSize: '16px',
    fontFamily: 'RelativeBook',
    outline: 'none',
    backgroundColor: 'none',
    padding: '0 10px',
    border: 'none',
    boxShadow: 'none'
  }),
  placeholder: (base, state) => ({
    ...base,
    color: '#6e7b8c'
  }),
  singleValue: (base, state) => ({
    ...base,
    color: '#6e7b8c'
  }),
  indicatorSeparator: (base, state) => ({
    color: '#fff'
  }),
  menu: (base, state) => ({
    ...base,
    marginTop: '15px'
  }),
  option: (base, state) => ({
    ...base,
    color: '#6e7b8c',
    height: '100%',
    backgroundColor: '#fff',
    backgroundImage: state.isSelected ? 'linear-gradient(#f8f9fa, #f8f9fa)' : 'none'
  })
}

const renderDatePicker = ({
  className,
  input,
  label,
  type,
  options,
  components,
  placeholder,
  withPastDates,
  meta: { touched, error }
}: DateFieldProps) => (
  <FormField className={className}>
    <Label>{label}</Label>
    <StyledField hasError={touched && error}>
      {!withPastDates && (
        <DatePicker
          {...input}
          styles={customStyles}
          value={input.value}
          onChange={value => input.onChange(value)}
          onBlur={() => input.onBlur(input.value)}
          placeholder={placeholder}
          withPastDates={withPastDates}
        />
      )}
      {withPastDates && (
        <DobDatePicker
          {...input}
          styles={customStyles}
          value={input.value}
          onChange={value => input.onChange(value)}
          onBlur={() => input.onBlur(input.value)}
          placeholder={placeholder}
          withPastDates={withPastDates}
        />
      )}
      {touched && error && <Error>{error}</Error>}
    </StyledField>
  </FormField>
)

export default renderDatePicker



// WEBPACK FOOTER //
// ./src/helpers/fieldRenderers/DatePicker.js